// extracted by mini-css-extract-plugin
export default {"container3":"OrderDetailPage_container3__XUtu9","font":"OrderDetailPage_font__mSylE","div":"OrderDetailPage_div__ISNVy","box":"OrderDetailPage_box__ZfBM7"};